/* StatusRenderer.js */

"use strict";

//const _ = require('lodash');

class StatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("status-column");
        this._rootElem.component = this._model;

        this._cleanIcon = document.createElement("base-icon-gl");
        this._cleanIcon.dataset.icon = "common.success";
        this._cleanIcon.setAttribute("title", "Success");

        this._queuedIcon = document.createElement("base-icon-gl");
        this._queuedIcon.dataset.icon = "configdrift.queued";
        this._queuedIcon.setAttribute("title", "Queued");

        this._cancelledIcon = document.createElement("base-icon-gl");
        this._cancelledIcon.dataset.icon = "configdrift.cancelled";
        this._cancelledIcon.setAttribute("title", "Canceled");

        this._errorIcon = document.createElement("base-icon-gl");
        this._errorIcon.dataset.icon = "common.error";
        this._errorIcon.setAttribute("title", "Failed");
        this._errorIcon.dataset.invalid = "true";

        this._loadingIcon = document.createElement("base-icon-gl");
        this._loadingIcon.dataset.icon = "configdrift.started";
        this._loadingIcon.setAttribute("title", "Started");

        this._runningIcon = document.createElement("base-icon-gl");
        this._runningIcon.dataset.icon = "configdrift.started";
        this._runningIcon.setAttribute("title", "Running");

        this._rootElem.appendChild(this._cleanIcon);
        this._rootElem.appendChild(this._queuedIcon);
        this._rootElem.appendChild(this._cancelledIcon);
        this._rootElem.appendChild(this._errorIcon);
        this._rootElem.appendChild(this._loadingIcon);
        this._rootElem.appendChild(this._runningIcon);

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._cleanIcon.remove();
            this._cleanIcon = undefined;
            this._queuedIcon.remove();
            this._queuedIcon = undefined;
            this._cancelledIcon.remove();
            this._cancelledIcon = undefined;
            this._errorIcon.remove();
            this._errorIcon = undefined;
            this._loadingIcon.remove();
            this._loadingIcon = undefined;
            this._runningIcon.remove();
            this._runningIcon = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Clean", (this._onClean = this._onClean.bind(this)));
        this._model.on("Error", (this._onError = this._onError.bind(this)));
        this._model.on("Loading", (this._onLoading = this._onLoading.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Clean");
        this._model.removeAllListeners("Error");
        this._model.removeAllListeners("Loading");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setActiveIcon(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onClean(newVal) {
        this._setClean(newVal);
    }

    _onError(newVal) {
        this._setError(newVal);
    }

    _onLoading(newVal) {
        this._setLoading(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setActiveIcon(sts) {
        this._cleanIcon.classList.add("hidden");
        this._queuedIcon.classList.add("hidden");
        this._cancelledIcon.classList.add("hidden");
        this._errorIcon.classList.add("hidden");
        this._loadingIcon.classList.add("hidden");
        this._runningIcon.classList.add("hidden");
        switch (sts) {
            case "clean":
            case "success":
                this._cleanIcon.classList.remove("hidden");
                break;
            case "queued":
                this._queuedIcon.classList.remove("hidden");
                break;
            case "loading":
            case "started":
                this._loadingIcon.classList.remove("hidden");
                break;
            case "running":
                this._runningIcon.classList.remove("hidden");
                break;
            case "cancelled":
                this._cancelledIcon.classList.remove("hidden");
                break;
            case "error":
            case "failed":
                this._errorIcon.classList.remove("hidden");
                break;
        }
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = StatusColumnRenderer;
